import IMask from 'imask'
import { fromNumber } from 'long'

const Form = {
  init: () => {
    if (!document.querySelector('[data-custom-form]')) return
    // const targets = document.querySelectorAll('[data-custom-form]')
    // for (let i = 0; i < targets.length; i += 1) {
    //   targets[i].addEventListener('submit', Form.processForm)
    // }

    Form.phoneMask()
  },
  processForm: (event) => {
    event.preventDefault()
    const button = event.target.querySelector('button[type="submit"]');
    button.disabled = true;
    button.textContent = 'Submitting...';

    // grecaptcha.ready(function () {
    //   grecaptcha.execute('6Lcua20aAAAAADHqf1Vynh94pI9cu7wamoycFkoS', {
    //     action: 'contact'
    //   }).then(function (token) {
    //     event.target.querySelector('input[name="captcha"]').value = token;
    //     event.target.submit();
    //   });
    // });
  },
  phoneMask: () => {
    const fields = document.querySelectorAll('[data-field-phone]')
    for (let x = 0; x < fields.length; x += 1) {
      const current = fields[x];
      const maskOptions = {
        mask: '000-000-0000',
      };
      IMask(current, maskOptions)
    }
  },
}
export default Form